import { render, staticRenderFns } from "./v2activity.vue?vue&type=template&id=04078ed6&scoped=true&"
import script from "./v2activity.vue?vue&type=script&lang=js&"
export * from "./v2activity.vue?vue&type=script&lang=js&"
import style0 from "./v2activity.vue?vue&type=style&index=0&id=04078ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04078ed6",
  null
  
)

export default component.exports